/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { themeToken } from 'src/components/common/cpds/utils/cpds-utils';
import { Typo } from 'src/components/common/ui';
import { checkValue } from 'src/components/common/helper';
import { mediaQueryVals } from 'src/components/common/cpds/token/shared/common';

export const SignupText = styled(Typo.HTMLText).attrs({
  exClass: 'cpds-button-roman-book-11',
  tag: 'p',
})<{ color?: string }>`
  ${({
    theme: {
      styles: { cpds },
    },
    color,
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      color: ${checkValue(color) ? color : token?.v3_one_key_signup_text_color || '#191E3B'};
      text-align: center;
      && {
        font-size: 12px;
      }
    `;
  }}
`;

export const SignupContainer = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      margin-top: ${token?.spacing?.space_16};
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 4px;

      ${SignupText},
      .v3-one-key-sign-up-button {
        font-weight: 400 !important;
      }
      @media (max-width: ${mediaQueryVals.cpds_small_upper_limit}) {
        margin-bottom: 12px;
      }
      @media (max-width: 374px) {
        display: inline;
        width: 100%;
        text-align: center;
      }
    `;
  }}
`;

export const Description = styled(Typo.HTMLText).attrs({
  exClass: 'cpds-body-roman-book-08',
  tag: 'p',
})<{ color?: string }>`
  ${({
    theme: {
      styles: { cpds },
    },
    color,
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      color: ${checkValue(color) ? color : token?.v3_one_key_text_color || '#191E3B'};
      text-align: center;
      margin-top: 15px;
      && {
        line-height: 25px;
      }
    `;
  }}
`;

export const OnekeyImageContainer = styled.div`
  width: 260px;
  height: auto;
  max-height: 60px;
  .v3-one-key-image {
    object-fit: cover;
    width: 100%;
    height: auto;
    max-height: 60px;
  }
  @media (max-width: ${mediaQueryVals.cpds_small_upper_limit}) {
    margin-top: 12px;
  }
`;

const V3OneKeyComponentContainer = styled.div<{
  signinCtaBgColor?: string;
  signinCtaTextColor?: string;
  signupCtaColor?: string;
}>`
  ${({
    theme: {
      styles: { cpds },
    },
    signinCtaBgColor = '',
    signinCtaTextColor = '',
    signupCtaColor = '',
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      padding: 0;
      .v3-one-key-logo {
        width: 100%;
        height: 100%;
        max-width: 92px;
        max-height: 22px;
      }
      .v3-one-key-partner-logo {
        width: auto;
        height: 100%;
        max-width: 80px;
        max-height: 18px;
      }
      .v3-one-key-sign-in-button {
        margin-top: ${token?.spacing?.space_16};
        min-width: 160px;
        width: fit-content;
        font-size: 16px !important;
        line-height: 16px !important;
        background-color: ${checkValue(signinCtaBgColor)
          ? signinCtaBgColor
          : token?.v3_one_key_signin_cta_bg_color || '#1668E3'};
        color: ${checkValue(signinCtaTextColor)
          ? signinCtaTextColor
          : token?.v3_one_key_signin_cta_text_color || '#ffffff'};
      }
      .v3-one-key-sign-up-button {
        height: 28px !important;
        text-decoration: underline !important;
        line-height: 28px !important;
        span {
          line-height: 28px !important;
        }
        color: ${checkValue(signupCtaColor) ? signupCtaColor : token?.v3_one_key_signup_text_color || '#191E3B'};
      }
      @media (max-width: ${mediaQueryVals.cpds_small_upper_limit}) {
        padding: 0;
        ${Description} {
          font-size: 14px;
          line-height: 24px;
        }
        .v3-one-key-sign-in-button {
          max-height: 48px;
        }
        ${SignupText} {
          font-size: 12px;
          line-height: 16px;
          height: 16px !important;
          span {
            line-height: 16px !important;
          }
        }
        .v3-one-key-sign-up-button {
          font-size: 12px;
          line-height: 16px;
        }
      }
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export { V3OneKeyComponentContainer };
